/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 * @generated-id: b3c7817a482b
 */

import * as z from "zod";
import { foldersDestroyFolder } from "../../funcs/foldersDestroyFolder.js";
import { formatResult, ToolDefinition } from "../tools.js";

const args = {
  folder: z.string().describe(
    "The full path of the folder, including any nested folders. Must not be empty, and must not contain double slashes or leading/trailing slashes.",
  ),
};

export const tool$foldersDestroyFolder: ToolDefinition<typeof args> = {
  name: "delete-folder",
  description: `Deletes an existing folder from your media library

Deletes a folder and all assets within it.`,
  scopes: ["librarian"],
  annotations: {
    "title": "Delete Folder",
    "destructiveHint": true,
    "idempotentHint": true,
    "openWorldHint": false,
    "readOnlyHint": false,
  },
  args,
  tool: async (client, args, ctx) => {
    const [result] = await foldersDestroyFolder(
      client,
      args.folder,
      { fetchOptions: { signal: ctx.signal } },
    ).$inspect();

    if (!result.ok) {
      return {
        content: [{ type: "text", text: result.error.message }],
        isError: true,
      };
    }

    return formatResult(result.value);
  },
};
